import dayjs from "global/dayjs";

export const formatSessionStarted = (startedAt: string | undefined, now: dayjs.Dayjs = dayjs()) => {
  if (!startedAt) return undefined;
  const started = dayjs(startedAt);
  if (!started.isValid()) return undefined;

  return started.isSame(now, "day")
    ? `Started today at ${started.format("HH:mm")}`
    : `Started ${started.format("DD/MM/YYYY")} at ${started.format("HH:mm")}`;
};
